import * as React from "react";
import update from "immutability-helper";
import ScanditBarcodeScanner from "scandit-sdk-react";
import { connect, Dispatch } from "react-redux";
import { Action } from "helpers/action-helpers";
import { buildRawCode } from "helpers/epc-helpers";
import { ScanditEntryAction } from "components/main/actions";
import { Barcode, ScanSettings } from "scandit-sdk";
// import { getI18n } from 'services/i18n-service';
// import { translations } from 'types/translations';
import { Button } from "semantic-ui-react";
import { LanguageCode } from "types/tenants/language-code";
import { BaseModal } from "components/base-modal/component";

export interface Props {
  language?: LanguageCode;
  submit?: (
    productCode: string,
    serial: string,
    expiry: string,
    lotNumber: string
  ) => void;
}

interface State {
  isModalOpen: boolean;
  productCode: string;
  serialNumber: string;
  expiry: string;
  lotNumber: string;
}

class ScanInputModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.setProductCode = this.setProductCode.bind(this);
    this.setSerialNumber = this.setSerialNumber.bind(this);
    this.setExpiry = this.setExpiry.bind(this);
    this.setLotNumber = this.setLotNumber.bind(this);

    this.isFormValid = this.isFormValid.bind(this);
    this.isEmpty = this.isEmpty.bind(this);

    this.state = {
      isModalOpen: false,
      productCode: "",
      serialNumber: "",
      expiry: "",
      lotNumber: ""
    };
  }

  getScanSettings = () => {
    return new ScanSettings({
      enabledSymbologies: [
        Barcode.Symbology.CODE128,
        Barcode.Symbology.DATA_MATRIX
      ]
    });
  }

  public render() {
    // const i18n = getI18n();

    // const modalActionButton = (
    //   <Button
    //     className={'modal-confirm submit-manual-entry-button'}
    //     disabled={!this.isFormValid()}
    //     onClick={() => this.handleScan}>
    //     Confirm
    //   </Button>
    // );

    return (
      <BaseModal
        open={this.state.isModalOpen}
        modalProps={{
          className: "modal-manual-input",
          size: "large",
          onClose: this.handleClose,
          trigger: (
            <Button
              icon="picture outline"
              labelPosition="right"
              className="no-border-radius manual-entry-button neutral"
              onClick={this.handleOpen}
              content="Scan code"
            />
          )
        }}
        showHeaderClose={true}
        headerText="Scan code"
        closeHandler={this.handleClose}
        actionButton={undefined}
      >
          <ScanditBarcodeScanner
            // Library licensing & configuration options (see https://docs.scandit.com/stable/web/globals.html#configure)
            licenseKey={
              "ATHd3YSBEPy2IbZGcTxTVmwTvCL0eUu25Hi+e11DFzA8f9H5ekojjHhEMJjjQeDLKE2sUgJL0huxYu7uMU9Plf9Y/KBbJYK1QAJjFXFeqXGzdCRnHSjyGgovt2lKIHozCR0pjyMO5SgU9xN+dc756f0q0McgE9epjyppqCoFxjTf9KHV/43M7EgPhgipknfum3cKYfTQ0n/vfyjc3dy0k6fgRkUN2om2RwM9ZgDkbY969swcoTF9l1cUS5TKUkYKS+v46PoYUVo5RWPdlPLcRNNfv310o/BfiCd2GiGX+6LchSM3a/ADTBgl9v8P94SfN5nQSWX3IcfsmKBWFNK5zxJkIgd/pPR3LWA+CTNiAscoKj4WhnqZxOwSZtBHb4A3GTaTmpt7GnvcSCEMApMORBSrUTkPlNToaWNSj8FbyF/ZnPenJc3EYR5BkqboCGbnM4rivqhEYVWs1Tc510SOl6DyuyZMv5kZ0ITdONI1Pnth/sxYwL15rodNIj7BNXgvfNEPGUK6EqTZByY/2v2XbGzh182/5cx88/Wb0vP1NFONwRPyQXZTbw82RSxR8Uw9X6QjWUayqsptJRYlbAauvkn70Hc5zXMnkslhpXOFKy2FpDU8O1puv8WLfhG92lk+dxYyru3UHiWMEyuWM91UGFOd9lrrVaITOWwhx/enKerssSgkWkk5Fy4yrwENTHqVxD7wMduLKnOXIiE0vxwhW139mYXNDrRJ0YfJojVU4kjYUBzV/1R4M9+b0vN78oD90FoHjfv9CKUVJlpV5hb9QCz+3CssWUuqp7qBIIAkeLbFn4/KHks="
            }
            engineLocation="https://cdn.jsdelivr.net/npm/scandit-sdk@4.x/build" // could also be a local folder, e.g. "build"
            // Picker events
            onReady={() => console.log}
            onScan={(e: any) => {
              this.handleScan(e);
            }}
            onScanError={console.log}
            // videoFit={this.state.videoFit}
            guiStyle={"laser"}
            // Picker options
            scanSettings={this.getScanSettings()}
          />
      </BaseModal>
    );
  }

  private handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      if (this.isFormValid()) {
        console.log("AAA");
        // this.handleScan();
      }
    }
  }

  private handleOpen = () => {
    this.setState(
      update(this.state, {
        isModalOpen: { $set: true },
        productCode: { $set: "" },
        serialNumber: { $set: "" },
        expiry: { $set: "" },
        lotNumber: { $set: "" }
      })
    );

    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  private handleClose = () => {
    document.removeEventListener("keydown", this.handleKeyDown, false);

    this.setState(
      update(this.state, {
        isModalOpen: { $set: false }
      })
    );
  }

  private handleScan = (e: { barcodes: { data: string }[] }) => {
    if (this.props.submit) {
      this.props.submit("", e.barcodes[0].data, "", "");
      this.handleClose();
    }
  }

  private setProductCode(event: React.FormEvent<HTMLInputElement>) {
    this.setState(
      update(this.state, {
        productCode: { $set: event.currentTarget.value }
      })
    );
  }

  private setSerialNumber(event: React.FormEvent<HTMLInputElement>) {
    this.setState(
      update(this.state, {
        serialNumber: { $set: event.currentTarget.value }
      })
    );
  }

  private setExpiry(event: React.FormEvent<HTMLInputElement>) {
    this.setState(
      update(this.state, {
        expiry: { $set: event.currentTarget.value }
      })
    );
  }

  private setLotNumber(event: React.FormEvent<HTMLInputElement>) {
    this.setState(
      update(this.state, {
        lotNumber: { $set: event.currentTarget.value }
      })
    );
  }

  private isFormValid() {
    return true;
    // !this.isEmpty(this.state.productCode) &&
    //  !this.isEmpty(this.state.serialNumber) &&
    //  !this.isEmpty(this.state.expiry) &&
    //  !this.isEmpty(this.state.lotNumber);
  }

  private isEmpty(value: string) {
    return value === "";
  }
}

// tslint:disable-next-line:no-any
function mapDisptachToProps(dispatch: Dispatch<Action>): object {
  return {
    submit: (
      productCode: string,
      serial: string,
      expiry: string,
      lotNumber: string
    ) => {
      const epc = buildRawCode(productCode, serial, lotNumber, expiry);
      dispatch(new ScanditEntryAction(epc));
    }
  };
}

export default connect(
  null,
  mapDisptachToProps
)(ScanInputModal);



// WEBPACK FOOTER //
// ./src/components/scan-input-modal/ScanInputModal.tsx